import { Ldap } from './../../core/models/ldap';
import { Component, Input, ViewChild, ElementRef } from '@angular/core';
import { CryptoDataService } from 'app/core/services/crypto.data.service';
import { UtilsService } from 'app/environment/services/utils.service';
import { LdapService } from 'app/security/core/services/ldap.service';
import { NgForm } from '@angular/forms';
import { DateUtil } from 'app/core/utils/DateUtil';

@Component({
  selector: 'ldap-basic-configuration',
  templateUrl: 'ldap-basic-configuration.component.html',
  styleUrls: ['ldap-basic-configuration.component.scss']
})
export class LdapBasicConfigurationComponent {
  @Input() ldapConfiguration: Ldap;

  @ViewChild('ldapBasicConfigurationForm', { static: false }) ldapBasicConfigurationForm: NgForm;

  public metadata: any;

  constructor(private _ldapService: LdapService, private _cryptoDataService: CryptoDataService, public utilsService: UtilsService) { }

  ngOnInit() {

  }

  ngOnChanges() {
    this._ldapService.getLdapMetadata().subscribe(data => {
      if (data)
        this.metadata = data;
    });
    if (this.ldapConfiguration)
      this.ldapConfiguration.synchHour = DateUtil.calculateHoursToShowOrSave(this.ldapConfiguration.synchHour, true);
  }

  public encryptBasicSecurityPassword() {
    if (this.ldapConfiguration.password !== undefined && (this.ldapConfiguration.password.length > 0)) {
      this._cryptoDataService.encryptString(this.ldapConfiguration.password)

        .subscribe(result => {
          this.ldapConfiguration.password = result.encryptedPassword;
        });
    } else {
      this.ldapConfiguration.password = '';
    }
  }

    public isValid(): boolean {
        Object.keys(this.ldapBasicConfigurationForm.controls).forEach(c => this.ldapBasicConfigurationForm.controls[c].markAsTouched());
        return this.ldapConfiguration.enabled ? this.ldapBasicConfigurationForm.valid : true;
    }

  public changeCheck() {
    this.ldapConfiguration.enabled = !this.ldapConfiguration.enabled;
  }

  public setLimitsSyncHour(property) {
    if (property === 'synchHour') {
      if (this.ldapConfiguration.synchHour > 23)
        this.ldapConfiguration.synchHour = 23;
      if (this.ldapConfiguration.synchHour < 0)
        this.ldapConfiguration.synchHour = 0;
    }
  }
}
